<template>
  <div class="dictionaryManage" >
    <div class="search">
      <el-form inline>
        <el-form-item>
          <el-input
              v-model.trim="dictionaryName"
              placeholder="请输入字典名称"
              maxlength="20"
              clearable
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="isEnabled" placeholder="请选择状态" clearable>
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search">搜 索</el-button>
          <el-button type="plain" @click="reset">重 置</el-button>
        </el-form-item>
      </el-form>
      <el-button type="primary" @click="addDictionary">新增字典</el-button>
    </div>

    <new-table :data="tableData" :columns="columns" :pages="pages"/>
    <!-- 添加字典 -->
    <addDictionary ref="addDictionary" @complete="getList"/>
    <!-- 添加字典值 -->
    <addValue ref="addValue"/>
  </div>
</template>

<script>
import newTable from "@/components/new-table"
import addDictionary from "./comp/addDictionary";
import addValue from "./comp/addValue";

export default {
  data() {
    return {
      dictionaryName: '',
      isEnabled: '',
      options: [
        {
          value: 1,
          label: '启用'
        },
        {
          value: 0,
          label: '停用'
        }
      ],
      tableData: [],
      columns: [
        {label: "字典名称", prop: "dictName"},
        {label: "字典代码", prop: "dictKey"},
        {label: "状态",
          render: (h,{ row }) => {
            return <el-switch  value={ Boolean(row.isEnabled) } disabled></el-switch>
          }
        },
        { label: "操作",
          render: (h,{ row }) =>{
            return <div>
              { !row.isSystem?<el-button type="text" onClick={ () => this.editDictionary(row) }>编辑</el-button>:'' }
              <el-button type="text" onClick={ () => this.addValue(row.id) }>添加字典值</el-button>
              { !row.isSystem?<el-button type="text" style="color: #fa5d5f" onClick={ () => this.delDictionary(row.id) }>删除</el-button>:'' }
            </div>
          }
        }
      ],
      pages: {
        props: {
          "page-size": 20,
          "current-page": 1,
          total: 0,
        },
        on: {
          "current-change": (p) => {
            this.currentChange(p);
          },
          "size-change":(p) => {
            this.sizesChange(p)
          }
        },
      },
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      this.$axios.get(`/Crm/Dictionary/DictionaryPageList?pageIndex=${ this.pages.props["current-page"]
      }&pageSize=${ this.pages.props["page-size"]
      }&dicName=${ this.dictionaryName
      }&isEnabled=${ this.isEnabled !== ''?this.isEnabled:-1 }`).then(res => {
        this.tableData = res.data;
        this.pages.props.total = res.dataCount;
      })
    },
    search() {
      this.pages.props["current-page"] = 1;
      this.getList();
    },
    addDictionary() {
      this.$refs.addDictionary.open();
    },
    editDictionary(row) {
      this.$refs.addDictionary.open(row);
    },
    delDictionary(id) {
      this.$confirm("确定要删除该字典吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axios.delete(`/Crm/Dictionary/DictionaryById?dicId=${ id }`).then(() => {
          this.$message.success(`删除成功`);
          this.tableData.length == 1 && this.pages.props["current-page"] != 1 && (this.pages.props["current-page"] -= 1);
          this.getList();
        })
      }).catch(() => {});
    },
    addValue(id) {
      this.$refs.addValue.open(id);
    },
    reset() {
      this.dictionaryName = '';
      this.isEnabled = '';
      this.search();
    },
    currentChange(p) {
      this.pages.props['current-page'] = p;
      this.getList();
    },
    sizesChange(s) {
      this.pages.props["current-page"] = 1;
      this.pages.props["page-size"] = s;
      this.getList();
    },
  },
  components: {
    newTable,
    addDictionary,
    addValue
  }
}
</script>

<style scoped lang="scss">
  .dictionaryManage {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .search {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
    }
  }
</style>